import src from "IMAGE";
export default { src, width: 902, height: 176, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42i3IOwqAMAwA0IpC6BKwhARcFBwEB1Hbsb/7n6op9I3PTMOsvlTLG3MFALuo/gYRLRGhiKzXsd/P5kL4fToVM7sGnLsFxU3UPNkAAAAASUVORK5CYII="};
